import { render, staticRenderFns } from "./DataTable.vue?vue&type=template&id=ebe610a6&scoped=true"
import script from "./DataTable.vue?vue&type=script&lang=js"
export * from "./DataTable.vue?vue&type=script&lang=js"
import style0 from "./DataTable.vue?vue&type=style&index=0&id=ebe610a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebe610a6",
  null
  
)

export default component.exports